module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-227.a3da6c0.woff2";